import type { DataTableHeader } from 'vuetify'

type Align = 'start' | 'center' | 'end'

export class Header implements DataTableHeader {
  text: string
  value: string
  sortable: boolean
  align?: Align
  width: number
  class?: string | string[]

  constructor(text: string, value: string, sortable?: boolean, align?: Align, width?: number, cssClass?: string) {
    this.text = text + ' '
    this.value = value
    this.sortable = sortable === undefined ? true : sortable
    this.align = align
    this.width = width
    this.class = cssClass
  }
}
